export default "__VITE_ASSET__BmtbrMXA__"